import React, { useCallback } from 'react';
import ReactMarkdown, { defaultUrlTransform } from 'react-markdown';

function platformUrlTransform(url) {
  if (typeof url !== 'undefined' && url.startsWith('contentItem:') && typeof window !== 'undefined') {
    url = window.location.pathname.split('/').slice(0, 3).join('/') + '/' + url.substr(url.indexOf(':') + 1);
  }
  return defaultUrlTransform(url);
}

export default function PlatformReactMarkdown({ className, escapeHtml, source, transformLinkurl, children, ...props }) {
  const urlTransform = useCallback(
    _url => {
      const url = transformLinkurl ? transformLinkurl(_url) : _url;
      return platformUrlTransform(url);
    },
    [transformLinkurl]
  );
  const ret = (
    <ReactMarkdown urlTransform={urlTransform} {...props}>
      {source && !children ? source : children}
    </ReactMarkdown>
  );
  return className ? <span className={className}>{ret}</span> : ret;
}
